export const SET_CODE = "SET_CODE";
export const TOGGLE_MENU = "TOGGLE_MENU";



// WEBPACK FOOTER //
// ./src/constants/index.js